import React from "react";
import TextField from "../reusable/TextInput";
import { tw } from "@careinfo/tailwind";

const Hubform = ({ register, errors }) => {
  return (
    <div className={tw`grid `}>
      <TextField
        label={"Name"}
        register={register("name", {
          required: "Name is required",
        })}
        errors={errors?.name}
      />
      <div className={tw`w-full  text-left mt-1`}>
        <label htmlFor="">Description</label>
        <textarea
          rows={3}
          className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
          {...register("description")}
        />
        {errors?.description && (
          <p className={tw`text-red-500 text-xs my-1`}>
            {errors?.description?.message}
          </p>
        )}
      </div>
    </div>
  );
};

export default Hubform;
